import React from "react";
import { connect } from "react-redux";
import { userActions } from "../../redux/_actions";
import axios from "axios";
import severUrl from "../../api";
import titac from "../../assets/images/64.png";
import Modal from "../modal/Modal";
import "../../assets/css/Fireworks.css"; // Import your CSS file here

class Tictac extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        password: "",
        username: "",
      },
      submitted: false,
      showProgress: false,
      isModalShowing: false,
      modaltoggle: false,
      adminCode: "*****",
      modalIndex: "Login",
      showFireworks: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onCodeChange = this.onCodeChange.bind(this);
    this.checkAdminCode = this.checkAdminCode.bind(this);
  }

  componentDidMount() {
          // Display fireworks and welcome message for 5 seconds on new visits
      this.setState({ showFireworks: true });
      setTimeout(() => {
        this.setState({ showFireworks: false });
      }, 5000);
    const userString = localStorage.getItem("user");

    if (userString) {
      try {
        const userObj = JSON.parse(userString);
        this.setState({
          user: {
            ...userObj,
          },
        });
      } catch (e) {
        console.error("Error parsing user from localStorage", e);
      }
    } else {
    }
  }

  handleChange(event) {
    const { name, value } = event.target;
    const { user } = this.state;
    this.setState({
      user: {
        ...user,
        [name]: value,
      },
    });
  }

  toggle(index) {
    this.setState({ modalIndex: !this.state.modalIndex });
    this.setState({ isModalShowing: !this.state.isModalShowing });
    this.setState({ modalIndex: index });
    document.body.style.overflow = !this.state.isModalShowing ? "hidden" : "scroll";
  }

  handleSubmit(event) {
    event.preventDefault();
    console.log("log log");
    this.setState({ submitted: true });
    const { user } = this.state;
    if (user.username && user.password) {
      var bodyFormData = new FormData();
      bodyFormData.append("username", user.username);
      bodyFormData.append("password", user.password);
      axios
        .post(severUrl + `registration/login_user`, bodyFormData)
        .then((response) => {
          localStorage.setItem("user", JSON.stringify(response.data));
          window.location.reload();
        });
    }
  }

  checkAdminCode(event) {
    console.log("chek chek");
    event.preventDefault();
    var bodyFormData = new FormData();
    const { adminCode } = this.state;
    bodyFormData.append("admin_code", adminCode);
    axios
      .post(severUrl + `users/admin_code`, bodyFormData)
      .then((response) => {
        console.log("answering");
        console.log(response.data.result);
        if (response.data.result === "OK") {
          this.setState({ showProgress: true });
        }
      });
  }

  onCodeChange(event) {
    this.setState({ adminCode: event.target.value });
  }

  render() {
    const appId = "6751130193"; 
    const appStoreUrl = `https://apps.apple.com/app/id${appId}`;

    return (
      <div style={{ textAlign: "center", padding: "0px" }}>
        
        {/* Pure CSS Fireworks Overlay with Welcome Text */}
        {this.state.showFireworks && (
          <div className="fireworks-container">
            <h2 className="welcome-text">Cheers to our first users joining the Tictac journey!</h2>
            <div className="firework firework-1"></div>
            <div className="firework firework-2"></div>
            <div className="firework firework-3"></div>
          </div>
        )}

        <p style={{ margin: "60px" }}></p>
        
        <img 
          src={titac} 
          alt="Tictac Logo" 
          style={{ 
            display: "block", 
            margin: "0 auto", 
            borderRadius: "15px"
          }} 
        />
        
        <h1 style={{ fontWeight: "bold", color: "black", margin: "10px 0 5px 0" }}>
          Tictac
        </h1>
        
        <p style={{ fontSize: "14px", color: "gray", margin: "0 0 5px 0" }}>
          A social platform for interacting and applying Machine Learning concepts.
        </p>
        
        <p style={{ fontSize: "14px", color: "gray", margin: "0 0 15px 0" }}>
          Available now on the App Store!
        </p>
        
        <div style={{ display: "flex", justifyContent: "center" }}>
          <a 
            href={appStoreUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ display: "inline-block" }}
          >
            <img 
              src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&releaseDate=1234567890" 
              alt="Download on the App Store" 
              style={{ width: "160px", height: "auto", display: "block" }} 
            />
          </a>
        </div>
      </div>
    );
  }
}

function mapState(state) {
  const registration = state.registration || {};
  const registering = registration.registering;
  return { registering };
}

const actionCreators = {
  register: userActions.register,
};

const connectedRegisterPage = connect(mapState, actionCreators)(Tictac);
export { connectedRegisterPage as Tictac };